var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"id":"StreamListView","title":_vm.$t('common.pageTitle'),"primaryAction":{
    label: _vm.$t('common.createStream.action'),
    onAction: _vm.createStream
  },"secondaryActions":[{
    label: _vm.$t('common.Notes'),
    onAction: function () { return _vm.eventHub.$emit('showAccountNotes', 'STREAM'); }
  }],"size":"fullWidth"}},[_c('Card',[_c('Filters',{attrs:{"filters":[
        {
          key: 'status',
          label: _vm.$t('common.Status'),
          type: 'select',
          multiple: true,
          options: [
            {value: 'draft', label: _vm.$t('common.status.draft') },
            {value: 'published', label: _vm.$t('common.status.published') },
            {value: 'deleted', label: _vm.$t('common.status.archived') },
            {value: 'disabled', label: _vm.$t('common.status.disabled') }
          ]
        }
      ],"shortcuts":[
        {
          label: _vm.$t('common.Status'),
          items: [
            {
              label: _vm.$t('common.Any'),
              onAction: function () { return _vm.setFilter('status', null); }
            },
            {
              label: _vm.$t('common.status.draft'),
              onAction: function () { return _vm.setFilter('status', ['draft']); }
            },
            {
              label: _vm.$t('common.status.published'),
              onAction: function () { return _vm.setFilter('status', ['published']); }
            },
            {
              label: _vm.$t('common.status.archived'),
              onAction: function () { return _vm.setFilter('status', ['deleted']); }
            },
            {
              label: _vm.$t('common.status.disabled'),
              onAction: function () { return _vm.setFilter('status', ['disabled']); }
            }
          ]
        }
      ],"applied-filters":_vm.appliedFilters,"query":_vm.query},on:{"update:applied-filters":_vm.updateFilter,"update:query":function($event){_vm.query=$event}}}),_c('DataTable',{attrs:{"loading":!_vm.filteredStreams,"columns":_vm.columns,"rows":_vm.filteredStreams || [],"row-actions":_vm.rowActionGenerator},scopedSlots:_vm._u([{key:"col:id",fn:function(ref){
      var row = ref.row;
return [_c('PageLink',{on:{"click":function($event){return _vm.onClickRow(row)}}},[_vm._v(_vm._s(row.id))])]}},{key:"col:status",fn:function(ref){
      var row = ref.row;
return [_c('Badge',{attrs:{"status":_vm.getStreamBadge(row).status}},[_vm._v(_vm._s(_vm.getStreamBadge(row).label))])]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }